import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconComponent = {
    alias: 'component',
    defaultTitle: 'Component',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm13.667 22-.061-.002a.999.999 0 0 1-.92-.8l-1.537-7.566a.999.999 0 0 0-.781-.781L2.8 11.31a.998.998 0 0 1-.117-1.927l16-5.332a1.001 1.001 0 0 1 1.265 1.264l-5.334 16a.998.998 0 0 1-.948.684' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm7.867 9.098 5.198 1.057a.996.996 0 0 1 .781.78l1.056 5.198L18.42 5.58 7.867 9.098ZM14.667 21c-.021 0-.041-.002-.061-.003a1 1 0 0 1-.92-.797l-1.67-8.217-8.215-1.67a.999.999 0 0 1-.118-1.929l16-5.333a1.002 1.002 0 0 1 1.266 1.265l-5.334 16a1 1 0 0 1-.948.684Z' }))),
};
